<template>
    <li class="izk-course-new">
        <div class="card-pic">
            <img :src="course.picture_url" :alt="course.title" @click='goDetail'/>
            <span class="g-btn3" v-if="course.sub_status">已预约</span>
            <a href="javascript:void(0)" class="g-btn3" v-if="!course.sub_status" @click="order">立即预约的</a>
        </div>
    </li>
</template>
<script>
	export default{
	  name: 'EightPicture',
	  props: {
	    course: {
	      type: Object,
	      default: {},
	      required: true
	    }
	  },
	  data(){
	    return {

	    }
	  },
	  methods: {
    order(){
      this.$emit('order', this.course);
    },
    goDetail(){
      this.$emit('goDetail', this.course);
    }
	  },
	  created(){

	  }
	}
</script>


// WEBPACK FOOTER //
// src/components/courseCenter/eight/public/Picture.vue